import React, { useState } from "react";
import { Dashboard } from "../../DashboardPage/useDashboard";

import CommitteeHeader from "../CommitteeHeader";
import CommitteeMemberItem from "../CommitteeMemberItem";
import DiamondCardModalWrapper from "../../Shared/DiamondCardModalWrapper";

import styles from "./CommitteesItem.module.css";

export function CommitteesItem({
  committee,
  readOnly,
  archived,
  onArchive,
  onEdit,
  onDelete,
  onSwapCompleted,
  onUpdateCompleted,
}) {
  const { data } = Dashboard.useContainer();
  const [showDiamondModal, setShowDiamondModal] = useState(false);
  const [user, setUser] = useState(null);

  const onClickPhoto = (member) => {
    if (!member || !member._id || !data || !data.users) {
      return;
    }

    const user = data.users.find((a) => a._id == member._id);
    if (user) {
      user.activeTab =
        `${user.profile.firstName} ${user.profile.lastName}`.toLowerCase() ==
        member.name.toLowerCase()
          ? 1
          : 2;
      setUser(user);
      setShowDiamondModal(true);
    }
  };

  const disposeData = () => {
    setShowDiamondModal(false);
    setUser(null);
  };

  const _getMemberPhoto = (member) => {
    const user =
      data && data.users ? data.users.find((a) => a._id == member._id) : null;
    if (user) {
      const profile = [user.profile, user.profileB || {}].find(
        (profile) =>
          `${profile.firstName} ${profile.lastName}` == member.name &&
          profile.photoUrl
      );

      if (profile) return profile.photoUrl;
    }

    return member.photoUrl;
  };

  return (
    <>
      {showDiamondModal && user && (
        <DiamondCardModalWrapper
          user={user}
          onClose={() => disposeData()}
          onUpdateCompleted={onUpdateCompleted}
          onSwapCompleted={onSwapCompleted}
          activeTab={user.activeTab}
        />
      )}
      <div className={styles.committeeContainer}>
        <CommitteeHeader
          readOnly={readOnly}
          title={committee.name}
          description={committee.description}
          year={committee.yearStarted}
          archived={archived}
          onArchive={onArchive}
          onEdit={onEdit}
          onDelete={onDelete}
        />
        <div className={styles.memberGrid}>
          {committee.members.map((member, index) => (
            <span key={index}>
              <CommitteeMemberItem
                name={member.name}
                year={member.yearStarted}
                photo={_getMemberPhoto(member)}
                onClickPhoto={() => onClickPhoto(member)}
              />
            </span>
          ))}
        </div>
      </div>
    </>
  );
}
